import * as React from 'react';
import { Query } from 'react-apollo';

import {
  DashboardFilterInput,
  DashboardTrendGranularity,
  FETCH_DASHBOARD_TREND_QUERY,
  FetchDashboardTrendQueryResult
} from './Dashboard.queries';
import { GranularityToggle } from './GranularityToggle';
import { TrendChart } from './TrendChart';

interface TrendSectionProps {
  filterInput: DashboardFilterInput;
  granularity: DashboardTrendGranularity;
  onGranularityChange: (granularity: DashboardTrendGranularity) => void;
}

const GRANULARITY_OPTIONS: Array<{ granularity: DashboardTrendGranularity; label: string }> = [
  { granularity: DashboardTrendGranularity.DAILY, label: 'Daily' },
  { granularity: DashboardTrendGranularity.WEEKLY, label: 'Weekly' },
  { granularity: DashboardTrendGranularity.MONTHLY, label: 'Monthly' }
];

export const TrendSection = (props: TrendSectionProps) => {
  const { filterInput, granularity, onGranularityChange } = props;

  return (
    <div className="Dashboard__card">
      <div className="Dashboard__card-header">
        <div>
          <h3 className="Dashboard__card-title">Order &amp; Revenue Trend</h3>
          <p className="Dashboard__card-subtitle">
            {granularity === DashboardTrendGranularity.MONTHLY
              ? 'All months in the selected year'
              : 'In the selected period'}
          </p>
        </div>
        <div className="Dashboard__toggle-group">
          {GRANULARITY_OPTIONS.map((option: { granularity: DashboardTrendGranularity; label: string }) => (
            <GranularityToggle
              granularity={option.granularity}
              isActive={option.granularity === granularity}
              key={option.granularity}
              label={option.label}
              onSelect={onGranularityChange}
            />
          ))}
        </div>
      </div>

      <Query<FetchDashboardTrendQueryResult>
        query={FETCH_DASHBOARD_TREND_QUERY}
        variables={{ input: filterInput, granularity }}
      >
        {({ loading, error, data }) => {
          if (loading) return <div className="Dashboard__loading">Loading trend...</div>;
          if (error) return <div className="Dashboard__error">Failed to load trend</div>;
          if (!data || !data.dashboardTrend) return <div className="Dashboard__empty">No trend data available</div>;

          return <TrendChart points={data.dashboardTrend} />;
        }}
      </Query>
    </div>
  );
};
